import LoadingButton from '@/common/components/base/button/loadingButton';
import RadioGroup from '@/common/components/base/input/radioGroup/RadioGroup';
import MainModal from '@/common/components/base/modal/Modal.tsx';
import { MainModalProps } from '@/common/components/base/modal/Modal.type.ts';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import usePlateDesignRequest from '@/common/hooks/usePlateDesignRequest';
import useVehicleTypeRequest from '@/common/hooks/useVehicleTypeRequest';
import { ADJUSTER_REPORT_DAMAGED_LINKS } from '@/modules/adjusterReportModules/adjusterReport/links/damaged/damagedLinks';
import AddDamagedFormRender from '@/modules/adjusterReportModules/IncidentParticipants/components/addDamagedPerson/AddDamagedFormRender';
import useAddDamagedPersonForms from '@/modules/adjusterReportModules/IncidentParticipants/components/addDamagedPerson/hooks/useAddDamagedPersonForms';
import { participantsIncidentQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/participantsIncidentList/participantsIncidentQueryOptions';
import { DamagedPersonFormData } from '@/modules/adjusterReportModules/IncidentParticipants/types/addDamagedPerson.type';
import { useQueryClient } from '@tanstack/react-query';
import { FormProvider } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { css } from 'styled-system/css';
import { Box } from 'styled-system/jsx';

const AddDamagedPersonModal = ({ open, closeModal }: MainModalProps) => {
  useVehicleTypeRequest({ enabled: true });
  usePlateDesignRequest({ enabled: true });
  return (
    <MainModal closeModal={closeModal} open={open}>
      <AddDamagedPerson closeModal={closeModal} />
    </MainModal>
  );
};

const AddDamagedPerson = ({
  closeModal,
}: {
  closeModal: MainModalProps['closeModal'];
}) => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { id } = useParams();
  const { methods, postApi, isPending } = useAddDamagedPersonForms({
    postOnSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: participantsIncidentQueryOptions({ id: id! }).queryKey,
      });
      closeModal();
      navigate(
        ADJUSTER_REPORT_DAMAGED_LINKS.damagedListInformation({ id: id! }),
        { replace: true },
      );
    },
  });

  const onSubmit = (formData: DamagedPersonFormData) => {
    postApi({ formData, id: +id! });
  };
  return (
    <FormProvider {...methods}>
      <TitleDescription>افزودن زیان‌دیده</TitleDescription>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <Box overflowY="hidden">
          <Box mt="1rem" maxHeight="70vh" scrollbar={'hidden'} overflowY="auto">
            <RadioGroup
              wrapperClassName={css({ mt: '2rem' })}
              className={css({ gap: '2rem' })}
              title="نوع زیان‌دیده"
              name="damaged_type"
              options={[
                { label: 'وسیله نقلیه', value: 'VEHICLE' },
                { label: 'سایر', value: 'OTHER' },
              ]}
              renderRadioButton={(Component) => <Box>{Component}</Box>}
            />
            <RadioGroup
              wrapperClassName={css({ mt: '2rem' })}
              className={css({ gap: '2rem' })}
              title="نوع مالکیت"
              name="owner_type"
              options={[
                { label: 'حقیقی', value: 'real' },
                { label: 'حقوقی', value: 'legal' },
              ]}
              renderRadioButton={(Component) => <Box>{Component}</Box>}
            />
            <AddDamagedFormRender />
          </Box>
        </Box>
        <LoadingButton loading={isPending} type="submit" my="20px" fullWidth>
          افزودن زیان‌دیده
        </LoadingButton>
      </form>
    </FormProvider>
  );
};
export default AddDamagedPersonModal;
